import { render, staticRenderFns } from "./newsCentralDetail.vue?vue&type=template&id=6b2c398a&scoped=true&"
import script from "./newsCentralDetail.vue?vue&type=script&lang=js&"
export * from "./newsCentralDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsCentralDetail.vue?vue&type=style&index=0&id=6b2c398a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c398a",
  null
  
)

export default component.exports